import { render, staticRenderFns } from "./articlenumberelement.vue?vue&type=template&id=9c7c0b7e&"
import script from "./../../ts/articleattributes/articlenumberelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/articlenumberelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports